import React from 'react';

import useAnimatedLoaderStyles from './styles';
import Lottie from 'lottie-react';
import loaderAnimation from '../../assets/animation/loader-Animation.json'

const AnimatedLoader = () => {
  const classes = useAnimatedLoaderStyles();
  return <div className={classes.root}>
    <div className=" bg-white z-50">
      <div style={{ height: '100vh', width: '100%',  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ height: '240px', width: '240px' }}>
          <Lottie animationData={loaderAnimation} />
        </div>
      </div>
    </div>
  </div>
};

AnimatedLoader.propTypes = {};

export default AnimatedLoader;
